<template>
  <div class="one-place">
    <div class="one-place__mobile-gradient"></div>
    <h2>{{ displayTitle }}</h2>
    <p>{{ displayDescription }}</p>
    <div class="one-place__body">
      <carousel class="one-place__carousel" :per-page="1" :mouse-drag="true" :navigateTo="navigateTo" :paginationEnabled="false" @page-change="slideChange">
        <slide v-for="(option, i) in displayOptions" :key="i">
          <img v-if="images[i]" :src="images[i]" :alt="option.title" loading="lazy" decoding="async">
          <div class="one-place__carousel-nav">
            <span :class="{active: index == navigateTo}" v-for="(slide, index) in displayOptions.length" :key="index" @click="navigateTo = index"></span>
          </div>
          <h3>{{option.title}}</h3>
          <p>{{option.desc}}</p>
        </slide>
      </carousel>
      <div class="one-place__options">
        <div class="one-place__option" v-for="(option, i) in displayOptions" :key="i" @click="changeActiveOption(i)" :class="{active: i == activeOption}">
          <h3>{{option.title}}<span :class="{active: i == activeOption}"></span></h3>
          <p v-if="i == activeOption">{{option.desc}}</p>
        </div>
      </div>
      <div class="one-place__details">
        <img
          v-if="images[activeOption]"
          :src="images[activeOption]"
          :alt="activeOptionTitle"
          loading="lazy"
          decoding="async"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'components/libs/vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return {
      activeOption: 0,
      navigateTo: 0
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.$t("onePlaceTitle");
    },
    displayDescription() {
      return this.description || this.$t("onePlaceDescription");
    },
    displayOptions() {
      if (this.options.length > 0) return this.options;
      
      return [
        {
          title: this.$t('onePlaceTitle1'),
          desc: this.$t('onePlaceOption1')
        },
        {
          title: this.$t('onePlaceTitle2'),
          desc: this.$t('onePlaceOption2')
        },
        {
          title: this.$t('onePlaceTitle3'),
          desc: this.$t('onePlaceOption3')
        },
        {
          title: this.$t('onePlaceTitle4'),
          desc: this.$t('onePlaceOption4')
        }
      ];
    },
    activeOptionTitle() {
      return this.displayOptions[this.activeOption]
        ? this.displayOptions[this.activeOption].title
        : '';
    }
  },
  methods: {
    changeActiveOption(i){
      this.activeOption == i ? this.activeOption = -1 : this.activeOption = i
      this.navigateTo = i
    },
    slideChange(i){
      this.navigateTo = i
    }
  }
}
</script>

<style lang="scss" scoped>
.one-place {
  padding-top: 110px;
  padding-bottom: 135px;
  position: relative;

  @media (max-width: 767px) {
    padding-top: 56px;
    margin-top: 56px;
    padding-bottom: 0;
  }

  & > h2 {
    font-size: 31px;
    font-weight: bold;
    text-align: center;
    color: rgb(27, 39, 51);

    @media (max-width: 767px) {
      display: none;
    }
  }

  & > p {
    margin-top: 12px;
    margin-bottom: 50px;
    font-size: 14px;
    text-align: center;
    color: rgb(27, 39, 51);

    @media (max-width: 767px) {
      display: none;
    }
  }
}

.one-place__body {
  display: flex;
  justify-content: space-between;
}

.one-place__options {
  width: 420px;

  @media (max-width: 1024px) {
    width: 44%;
  }

  @media (max-width: 767px) {

  }
}

.one-place__option {
  border-radius: 4px;
  padding: 18px 20px;
  margin-bottom: 8px;
  cursor: pointer;

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: rgb(27, 39, 51);

    span {
      float: right;
      content: "";
      display: inline-block;
      background-image: url('../images/landing/arrow-blue.svg');
      width: 16px;
      height: 9px;
      background-size: cover;
      margin-top: 3px;

      &.active {
        transform: rotate(180deg);
      }
    }
  }

  p {
    font-size: 14px;
    line-height: 1.57;
    color: rgb(27, 39, 51);
    margin-top: 6px;
  }

  &:hover {
    background-color: rgba(42, 138, 234, .1);
  }

  &.active {
    background-color: rgba(42, 138, 234, .2);
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.one-place__details {
  width: 550px;
  height: 580px;

  img {
    width: 100%;
    box-shadow: 0 25px 30px 0 rgba(27, 39, 51, 0.2), 0 0 20px 0 rgba(27, 39, 51, 0.1);
    border-radius: 1px;
    @media (max-width: 1024px) {
      width: 100%;
      position: absolute;
      top: 0;
      margin: 0;
    }
  }

  @media (max-width: 1024px) {
    position: relative;
    width: 54%;
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.one-place__carousel {
  display: none;
  width: 100%;
  margin-top: -54px;

  img {
    width: 100%;
    box-shadow: 0 14px 40px 0 rgba(27, 39, 51, 0.26);
    border-radius: 1px;
  }

  @media (max-width: 767px) {
    display: block;
  }

  .VueCarousel-slide {
    visibility: visible;
    flex-basis: 100%;
  }

  ::v-deep(.VueCarousel-wrapper) {
    width: calc(100vw);
    margin-left: -24px;

    @media (max-width: 413px) {
      margin-left: -8px;
    }
  }

  ::v-deep(.VueCarousel-slide) {
    width: 100vw;
    padding: 54px 24px;

    @media (max-width: 413px) {
      padding: 54px 8px;
    }

    h3 {
      font-size: 31px;
      font-weight: bold;
      text-align: center;
      color: rgb(27, 39, 51);
      margin-top: 20px;

      @media (max-width: 413px) {
        font-size: 27px;
      }
    }

    p {
      margin-top: 16px;
      font-size: 14px;
      line-height: 1.71;
      text-align: center;
      color: rgb(27, 39, 51);
    }
  }
}

.one-place__carousel-nav {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  span {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: rgba(42, 138, 234, .2);
    margin: 0 10px;
    cursor: pointer;
    display: inline-block;

    &.active {
      background-color: rgb(33, 136, 237);
    }
  }
}

.one-place__mobile-gradient {
  display: none;

  @media (max-width: 767px) {
    position: absolute;
    left: -24px;
    right: -24px;
    display: block;
    background-image: linear-gradient(to top, rgba(42, 138, 234, 0), rgba(42, 138, 234, .2));
    height: 294px;
    top: -1px;
  }

  @media (max-width: 413px) {
    left: -8px;
    right: -8px;
  }
}

</style>
